import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { useSelector } from 'react-redux';
import { getProductLevelFromApiNameString } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { getIsLatestVersionOfProductInProductInventorySelector, productVersionsFromProductInventorySelector } from '../../selectors/ProductInventorySelectors';
import { skuIdHasBundledProductsSelector } from '../../selectors/ProductsSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const Tag = ({
  children,
  color,
  backgroundColor
}) => /*#__PURE__*/_jsx(View, {
  backgroundColor: backgroundColor,
  alignSelf: "stretch",
  marginInline: "-400",
  borderStartStartRadius: "100",
  borderStartEndRadius: "100",
  children: /*#__PURE__*/_jsx(Text, {
    color: color,
    typography: "detail-100",
    paddingBlock: "100",
    children: children
  })
});
const FeatureTableColTag = ({
  apiName,
  recommendedProductLevel,
  showRecommended = false
}) => {
  const columnProductLevel = getProductLevelFromApiNameString(apiName);
  const isAppAuth = useSelector(isAppAuthSelector);
  const isAppReady = useGlobalLoading();
  const isCurrentPlan = useSelector(state => isAppReady && getIsLatestVersionOfProductInProductInventorySelector(state, {
    productIdentifier: {
      apiName
    }
  }) && isAppAuth);
  const ownsProductViaBundle = useSelector(state => {
    var _productVersionsFromP;
    if (!isAppReady || !isAppAuth) return null;
    const skuId = (_productVersionsFromP = productVersionsFromProductInventorySelector(state, {
      productAttributeFilters: {
        apiName
      }
    })[0]) === null || _productVersionsFromP === void 0 ? void 0 : _productVersionsFromP.skuId;
    if (!skuId) return null;
    return skuIdHasBundledProductsSelector(state, {
      skuId
    });
  });
  if (ownsProductViaBundle) return /*#__PURE__*/_jsx(Tag, {
    color: "text-core-default",
    backgroundColor: "fill-tertiary-pressed",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "featureTable.planTags.included"
    })
  });
  if (isCurrentPlan) return /*#__PURE__*/_jsx(Tag, {
    color: "text-core-default",
    backgroundColor: "fill-tertiary-pressed",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "featureTable.planTags.currentPlan"
    })
  });
  if (showRecommended && columnProductLevel === recommendedProductLevel) return /*#__PURE__*/_jsx(Tag, {
    color: "text-core-on-fill-default",
    backgroundColor: "fill-positive-default",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "featureTable.planTags.recommendedPlan"
    })
  });
  return null;
};
export default FeatureTableColTag;